import React, { useState, useRef } from "react";
import "./Contact.css";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarker,
  FaLinkedin,
  FaGithub,
  FaWhatsapp,
  FaPaperPlane,
  FaSpinner,
} from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const formRef = useRef();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [submitStatus, setSubmitStatus] = useState({
    success: false,
    message: "",
  });

  // HARD LOCK - prevents duplicate sends
  const sendingLockRef = useRef(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Block duplicate requests
    if (sendingLockRef.current) {
      console.log("Duplicate submission blocked");
      return;
    }

    sendingLockRef.current = true;
    setIsSubmitting(true);
    setSubmitStatus({
      success: false,
      message: "",
    });

    try {
      const serviceId = "Bhanu21624";
      const templateId = "template_3iig98r";
      const publicKey = "6JIDlNCS9tSFjAlH6";

      const templateParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || "Not provided",
        subject: formData.subject,
        message: formData.message,
        to_email: "Bhanuprakash21624@gmail.com",
      };

      console.log("Sending email...");

      const result = await emailjs.send(
        serviceId,
        templateId,
        templateParams,
        publicKey
      );

      console.log("EmailJS Result:", result);

      setSubmitStatus({
        success: true,
        message: "✅ Message sent successfully!",
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });

      // Unlock after successful send
      setTimeout(() => {
        sendingLockRef.current = false;
      }, 5000);
    } catch (error) {
      console.error("Email sending failed:", error);

      setSubmitStatus({
        success: false,
        message: "❌ Failed to send. Please try again.",
      });

      // Unlock immediately if failed
      sendingLockRef.current = false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendWhatsApp = () => {
    const phoneNumber = "918330971777";
    const message =
      "Hi Bhanu Prakash,\nI'm interested in connecting with you.";

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section className="contact">
      <div className="contact-container">
        <div className="contact-wrapper">
          {/* Left Side - Contact Info */}
          <div className="contact-info">
            <h2>Email</h2>
            <p className="email-address">Bhanuprakash21624@gmail.com</p>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon-wrapper email">
                  <FaEnvelope />
                </div>
                <div>
                  <h4>EMAIL</h4>
                  <p>Bhanuprakash21624@gmail.com</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon-wrapper phone">
                  <FaPhone />
                </div>
                <div>
                  <h4>PHONE</h4>
                  <p>+91 8330971777</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon-wrapper location">
                  <FaMapMarker />
                </div>
                <div>
                  <h4>LOCATION</h4>
                  <p>Bhimavaram, Andhra Pradesh</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon-wrapper whatsapp">
                  <FaWhatsapp />
                </div>
                <div>
                  <h4>WHATSAPP</h4>
                  <p>+91 8330971777</p>
                </div>
              </div>
            </div>

            <div className="contact-social">
              <a
                href="https://www.linkedin.com/in/bhanu-prakash-kollati-9684a5321/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>

              <a
                href="https://github.com/bhanuprakash21624"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub />
              </a>

              <a href="mailto:Bhanuprakash21624@gmail.com">
                <FaEnvelope />
              </a>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <form
            className="contact-form"
            ref={formRef}
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number (optional)"
                value={formData.phone}
                onChange={handleChange}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            {submitStatus.message && (
              <div
                className={`status-message ${
                  submitStatus.success ? "success" : "error"
                }`}
              >
                {submitStatus.message}
              </div>
            )}

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <FaSpinner className="spinner" /> Sending...
                </>
              ) : (
                <>
                  <FaPaperPlane /> Send Message
                </>
              )}
            </button>

            <div className="form-footer">
              <span>Or reach me directly on</span>

              <button
                type="button"
                className="whatsapp-btn"
                onClick={sendWhatsApp}
              >
                <FaWhatsapp /> WhatsApp
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;